"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Instruction = void 0;
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const sol_kit_1 = require("@raindrop-studios/sol-kit");
const pda_1 = require("../utils/pda");
const programIds_1 = require("../constants/programIds");
const namespace_1 = require("../state/namespace");
const splToken = __importStar(require("@solana/spl-token"));
const constants_1 = require("../constants");
class Instruction extends sol_kit_1.Instruction {
    constructor(args) {
        super(args);
    }
    async initializeNamespace(args, accounts) {
        const [namespacePDA, _namespaceBump] = await pda_1.getNamespacePDA(accounts.mint);
        const remainingAccounts = [];
        // add optional payment accounts first
        if (args.paymentAmount) {
            const paymentMint = {
                pubkey: accounts.paymentMint,
                isWritable: false,
                isSigner: false,
            };
            const paymentVault = {
                pubkey: accounts.paymentVault,
                isWritable: false,
                isSigner: false,
            };
            remainingAccounts.push(paymentMint, paymentVault);
        }
        else {
            args.paymentAmount = null;
        }
        // then add optional staking mints
        args.whitelistedStakingMints.map((mint) => {
            remainingAccounts.push({
                pubkey: mint,
                isWritable: false,
                isSigner: false,
            });
        });
        let ix;
        const permissivenessSettings = {
            namespacePermissiveness: namespace_1.convertPermissiveness(args.permissivenessSettings.namespacePermissiveness),
            itemPermissiveness: namespace_1.convertPermissiveness(args.permissivenessSettings.itemPermissiveness),
            playerPermissiveness: namespace_1.convertPermissiveness(args.permissivenessSettings.playerPermissiveness),
            matchPermissiveness: namespace_1.convertPermissiveness(args.permissivenessSettings.matchPermissiveness),
            missionPermissiveness: namespace_1.convertPermissiveness(args.permissivenessSettings.missionPermissiveness),
            cachePermissiveness: namespace_1.convertPermissiveness(args.permissivenessSettings.cachePermissiveness),
        };
        const formattedArgs = {
            desiredNamespaceArraySize: args.desiredNamespaceArraySize,
            uuid: args.uuid,
            prettyName: args.prettyName,
            permissivenessSettings: permissivenessSettings,
            whitelistedStakingMints: args.whitelistedStakingMints,
            paymentAmount: args.paymentAmount,
        };
        if (remainingAccounts.length > 0) {
            ix = await this.program.client.methods
                .initializeNamespace(formattedArgs)
                .accounts({
                namespace: namespacePDA,
                mint: accounts.mint,
                metadata: accounts.metadata,
                masterEdition: accounts.masterEdition,
                payer: this.program.client.provider.wallet
                    .publicKey,
                tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
                systemProgram: web3_js_1.SystemProgram.programId,
                rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            })
                .remainingAccounts(remainingAccounts)
                .instruction();
        }
        else {
            ix = await this.program.client.methods
                .initializeNamespace(formattedArgs)
                .accounts({
                namespace: namespacePDA,
                mint: accounts.mint,
                metadata: accounts.metadata,
                masterEdition: accounts.masterEdition,
                payer: this.program.client.provider.wallet
                    .publicKey,
                tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
                systemProgram: web3_js_1.SystemProgram.programId,
                rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            })
                .instruction();
        }
        return [[ix], namespacePDA];
    }
    async updateNamespace(args, accounts) {
        const [namespacePDA, _namespaceBump] = await pda_1.getNamespacePDA(accounts.namespaceMint);
        const payer = this.program.client.provider.wallet
            .publicKey;
        const nsTA = await splToken.Token.getAssociatedTokenAddress(splToken.ASSOCIATED_TOKEN_PROGRAM_ID, splToken.TOKEN_PROGRAM_ID, accounts.namespaceMint, payer);
        const remainingAccounts = args.whitelistedStakingMints.map((mint) => ({
            pubkey: mint,
            isWritable: false,
            isSigner: false,
        }));
        return [
            await this.program.client.methods
                .updateNamespace(args)
                .accounts({
                namespace: namespacePDA,
                namespaceToken: nsTA,
                tokenHolder: payer,
            })
                .remainingAccounts(remainingAccounts)
                .instruction(),
        ];
    }
    async createNamespaceGatekeeper(accounts) {
        const [namespacePDA, _namespacePDABump] = await pda_1.getNamespacePDA(accounts.namespaceMint);
        const [namespaceGatekeeperPDA, _namespaceGatekeeperBump] = await pda_1.getNamespaceGatekeeperPDA(namespacePDA);
        const payer = this.program.client.provider.wallet
            .publicKey;
        const nsTA = await splToken.Token.getAssociatedTokenAddress(splToken.ASSOCIATED_TOKEN_PROGRAM_ID, splToken.TOKEN_PROGRAM_ID, accounts.namespaceMint, payer);
        const ix = await this.program.client.methods
            .createNamespaceGatekeeper()
            .accounts({
            namespace: namespacePDA,
            namespaceToken: nsTA,
            namespaceGatekeeper: namespaceGatekeeperPDA,
            tokenHolder: payer,
            payer: payer,
            systemProgram: web3_js_1.SystemProgram.programId,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
        })
            .instruction();
        return [[ix], namespaceGatekeeperPDA];
    }
    async addToNamespaceGatekeeper(args, accounts) {
        const [namespacePDA, _namespacePDABump] = await pda_1.getNamespacePDA(accounts.namespaceMint);
        const [namespaceGatekeeperPDA, _namespaceGatekeeperBump] = await pda_1.getNamespaceGatekeeperPDA(namespacePDA);
        const payer = this.program.client.provider.wallet
            .publicKey;
        const nsTA = await splToken.Token.getAssociatedTokenAddress(splToken.ASSOCIATED_TOKEN_PROGRAM_ID, splToken.TOKEN_PROGRAM_ID, accounts.namespaceMint, payer);
        const itemArtifactFilter = {
            filter: args.artifactFilter.filter.filter,
            tokenType: namespace_1.convertTokenType(args.artifactFilter.tokenType),
        };
        return [
            await this.program.client.methods
                .addToNamespaceGatekeeper(itemArtifactFilter)
                .accounts({
                namespace: namespacePDA,
                namespaceToken: nsTA,
                namespaceGatekeeper: namespaceGatekeeperPDA,
                tokenHolder: payer,
            })
                .instruction(),
        ];
    }
    async removeFromNamespaceGatekeeper(args, accounts) {
        const [namespacePDA, _namespacePDABump] = await pda_1.getNamespacePDA(accounts.namespaceMint);
        const [namespaceGatekeeperPDA, _namespaceGatekeeperBump] = await pda_1.getNamespaceGatekeeperPDA(namespacePDA);
        const payer = this.program.client.provider.wallet
            .publicKey;
        const nsTA = await splToken.Token.getAssociatedTokenAddress(splToken.ASSOCIATED_TOKEN_PROGRAM_ID, splToken.TOKEN_PROGRAM_ID, accounts.namespaceMint, payer);
        const itemArtifactFilter = {
            filter: args.artifactFilter.filter.filter,
            tokenType: namespace_1.convertTokenType(args.artifactFilter.tokenType),
        };
        return [
            await this.program.client.methods
                .removeFromNamespaceGatekeeper(itemArtifactFilter)
                .accounts({
                namespace: namespacePDA,
                namespaceToken: nsTA,
                namespaceGatekeeper: namespaceGatekeeperPDA,
                tokenHolder: payer,
            })
                .instruction(),
        ];
    }
    async joinNamespace(accounts) {
        const [namespacePDA, _namespacePDABump] = await pda_1.getNamespacePDA(accounts.namespaceMint);
        const [namespaceGatekeeperPDA, _namespaceGatekeeperBump] = await pda_1.getNamespaceGatekeeperPDA(namespacePDA);
        const payer = this.program.client.provider.wallet
            .publicKey;
        const nsTA = await splToken.Token.getAssociatedTokenAddress(splToken.ASSOCIATED_TOKEN_PROGRAM_ID, splToken.TOKEN_PROGRAM_ID, accounts.namespaceMint, payer);
        const rainPayerAta = await splToken.Token.getAssociatedTokenAddress(splToken.ASSOCIATED_TOKEN_PROGRAM_ID, splToken.TOKEN_PROGRAM_ID, constants_1.Common.RAIN_TOKEN_MINT, payer);
        const rainTokenVault = await splToken.Token.getAssociatedTokenAddress(splToken.ASSOCIATED_TOKEN_PROGRAM_ID, splToken.TOKEN_PROGRAM_ID, constants_1.Common.RAIN_TOKEN_MINT, constants_1.Common.RAIN_TOKEN_VAULT_AUTHORITY);
        const nsData = await this.program.client.account.namespace.fetch(namespacePDA);
        const namespace = new namespace_1.Namespace(namespacePDA, nsData);
        let ix;
        if (nsData.paymentMint && nsData.paymentVault && nsData.paymentAmount) {
            const paymentAta = await splToken.Token.getAssociatedTokenAddress(splToken.ASSOCIATED_TOKEN_PROGRAM_ID, splToken.TOKEN_PROGRAM_ID, namespace.paymentMint, payer);
            const remainingAccounts = [
                {
                    pubkey: namespace.paymentMint,
                    isWritable: false,
                    isSigner: false,
                },
                {
                    pubkey: namespace.paymentVault,
                    isWritable: true,
                    isSigner: false,
                },
                {
                    pubkey: paymentAta,
                    isWritable: true,
                    isSigner: false,
                },
            ];
            ix = await this.program.client.methods
                .joinNamespace()
                .accounts({
                namespace: namespacePDA,
                namespaceToken: nsTA,
                artifact: accounts.artifact,
                namespaceGatekeeper: namespaceGatekeeperPDA,
                tokenHolder: payer,
                rainPayerAta: rainPayerAta,
                rainTokenVault: rainTokenVault,
                rainTokenMint: constants_1.Common.RAIN_TOKEN_MINT,
                raindropsProgram: namespace_1.RaindropsProgram.getRaindropsProgram(accounts.raindropsProgram),
                instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
            })
                .remainingAccounts(remainingAccounts)
                .instruction();
        }
        else {
            ix = await this.program.client.methods
                .joinNamespace()
                .accounts({
                namespace: namespacePDA,
                namespaceToken: nsTA,
                artifact: accounts.artifact,
                namespaceGatekeeper: namespaceGatekeeperPDA,
                tokenHolder: payer,
                rainPayer: payer,
                rainPayerAta: rainPayerAta,
                rainTokenVault: rainTokenVault,
                rainTokenMint: constants_1.Common.RAIN_TOKEN_MINT,
                raindropsProgram: namespace_1.RaindropsProgram.getRaindropsProgram(accounts.raindropsProgram),
                instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
            })
                .instruction();
        }
        return [ix];
    }
    async leaveNamespace(accounts) {
        const [namespacePDA, _namespacePDABump] = await pda_1.getNamespacePDA(accounts.namespaceMint);
        const [namespaceGatekeeperPDA, _namespaceGatekeeperBump] = await pda_1.getNamespaceGatekeeperPDA(namespacePDA);
        const payer = this.program.client.provider.wallet
            .publicKey;
        const nsTA = await splToken.Token.getAssociatedTokenAddress(splToken.ASSOCIATED_TOKEN_PROGRAM_ID, splToken.TOKEN_PROGRAM_ID, accounts.namespaceMint, payer);
        return [
            await this.program.client.methods
                .leaveNamespace()
                .accounts({
                namespace: namespacePDA,
                namespaceToken: nsTA,
                artifact: accounts.artifact,
                namespaceGatekeeper: namespaceGatekeeperPDA,
                tokenHolder: payer,
                raindropsProgram: namespace_1.RaindropsProgram.getRaindropsProgram(accounts.raindropsProgram),
                instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
            })
                .instruction(),
        ];
    }
    async cacheArtifact(accounts) {
        const [namespacePDA, _namespacePDABump] = await pda_1.getNamespacePDA(accounts.namespaceMint);
        const payer = this.program.client.provider.wallet
            .publicKey;
        const nsTA = await splToken.Token.getAssociatedTokenAddress(splToken.ASSOCIATED_TOKEN_PROGRAM_ID, splToken.TOKEN_PROGRAM_ID, accounts.namespaceMint, payer);
        // get lowest available page
        let page = new anchor_1.BN(0);
        const nsData = await this.program.client.account.namespace.fetch(namespacePDA);
        // sort ascending
        const fullPages = nsData.fullPages;
        const sortedFullPages = fullPages.sort();
        // increment 1 higher than the last full page
        if (sortedFullPages.length > 0) {
            page = sortedFullPages[sortedFullPages.length - 1].add(new anchor_1.BN(1));
        }
        const [index, _indexBump] = await pda_1.getIndexPDA(namespacePDA, page);
        const args = {
            page: page,
        };
        return [
            await this.program.client.methods
                .cacheArtifact(args)
                .accounts({
                namespace: namespacePDA,
                namespaceToken: nsTA,
                index: index,
                artifact: accounts.artifact,
                tokenHolder: payer,
                systemProgram: web3_js_1.SystemProgram.programId,
                rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
                raindropsProgram: namespace_1.RaindropsProgram.getRaindropsProgram(accounts.raindropsProgram),
                instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
            })
                .instruction(),
        ];
    }
    async uncacheArtifact(args, accounts) {
        const [namespacePDA, _namespacePDABump] = await pda_1.getNamespacePDA(accounts.namespaceMint);
        const payer = this.program.client.provider.wallet
            .publicKey;
        const nsTA = await splToken.Token.getAssociatedTokenAddress(splToken.ASSOCIATED_TOKEN_PROGRAM_ID, splToken.TOKEN_PROGRAM_ID, accounts.namespaceMint, payer);
        const [index, _indexBump] = await pda_1.getIndexPDA(namespacePDA, args.page);
        return [
            await this.program.client.methods
                .uncacheArtifact(args)
                .accounts({
                namespace: namespacePDA,
                namespaceToken: nsTA,
                index: index,
                artifact: accounts.artifact,
                tokenHolder: payer,
                systemProgram: web3_js_1.SystemProgram.programId,
                rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
                raindropsProgram: namespace_1.RaindropsProgram.getRaindropsProgram(accounts.raindropsProgram),
                instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
            })
                .instruction(),
        ];
    }
}
exports.Instruction = Instruction;
